// extracted by mini-css-extract-plugin
export default {"offerPage":"BDG0T","headerSpacing":"jv7Lm","benefitsSpacing":"SZdaX","loaderContainer":"GTU6C","dataQaElement":"YSHoW"};